// src/pages/locations/components/form/RecordMeta.tsx
import React from "react";

type Auditable = {
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};

function formatStamp(at?: string | null, by?: string | null): string | null {
  if (!at && !by) return null;

  const when = at
    ? new Date(at).toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : null;

  if (when && by) return `${when} by ${by}`;
  return when ?? `by ${by}`;
}

/** Provenance for a record being edited — who last touched it, and when. */
export const RecordMeta: React.FC<{ record: Auditable }> = ({ record }) => {
  const created = formatStamp(record.createdAt, record.createdBy);
  const updated = formatStamp(record.updatedAt, record.updatedBy);

  if (!created && !updated) return null;

  return (
    <div className="border-b border-gray-100 px-5 py-4 text-[11px] text-gray-500 last:border-b-0 sm:px-6">
      <dl className="flex flex-wrap gap-x-8 gap-y-1">
        {created && (
          <div className="flex gap-1.5">
            <dt className="font-semibold text-gray-600">Created</dt>
            <dd>{created}</dd>
          </div>
        )}
        {updated && (
          <div className="flex gap-1.5">
            <dt className="font-semibold text-gray-600">Last updated</dt>
            <dd>{updated}</dd>
          </div>
        )}
      </dl>
    </div>
  );
};
